import { bytesToMegabytes } from './common';
import { createImg } from './createImg';

const getImgPropsErrors = ({ imgProps, limits }) => {
  const { width, height, size } = imgProps;
  const { minWidth, minHeight, maxSize } = limits;

  const errMsgs = [];

  if (minWidth && !minHeight && width < minWidth) {
    errMsgs.push(
      `Минимальная ширина ${minWidth}. Ширина выбранного изображения - ${width}`
    );
  }

  if (!minWidth && minHeight && height < minHeight) {
    errMsgs.push(
      `Минимальная высота ${minHeight}. Высота выбранного изображения - ${height}`
    );
  }

  if (minWidth && minHeight && (width < minWidth || height < minHeight)) {
    errMsgs.push(
      `Минимальное разрешение ${minWidth} x ${minHeight}. Разрешение выбранного изображения - ${width} x ${height}`
    );
  }

  if (maxSize && size > maxSize) {
    errMsgs.push(
      `Максимальный размер - ${bytesToMegabytes(
        maxSize
      )} Мб. Размер выбранного изображения - ${bytesToMegabytes(size)}`
    );
  }

  return errMsgs;
};

export const getError = async ({ file, limits }) => {
  let msgs = [];

  if (limits) {
    try {
      const url = URL.createObjectURL(file);
      const { width, height } = await createImg(url);
      URL.revokeObjectURL(url);
      const { size } = file;
      const imgProps = { width, height, size };
      msgs = getImgPropsErrors({ imgProps, limits });
    } catch (err) {
      msgs.push(['Не удалось получить размеры изображения']);
    }
  }

  return msgs;
};
